import { LOGIN_ROUTE, getCurrentAuthUser } from '@/shared/lib/authSession';

type SessionExpiredDestination = '/session-expired' | typeof LOGIN_ROUTE;
type SessionExpiredNavigator = (destination: SessionExpiredDestination) => Promise<void>;

let navigation: Promise<void> | null = null;
let navigateToSessionDestination: SessionExpiredNavigator | null = null;

/**
 * Connect session-expiration handling to the app router during bootstrap.
 * Keeping this dependency injected prevents the API client from creating a
 * static import cycle through the generated route tree.
 */
export function registerSessionExpiredNavigator(navigator: SessionExpiredNavigator): void {
  navigateToSessionDestination = navigator;
}

/**
 * Move authenticated API traffic to the session-expired route while Firebase
 * still has a user, or directly to login when that session is already gone. The
 * API error still reaches its caller; this coordinator owns presentation only.
 */
export function showSessionExpired(): void {
  if (navigation || !navigateToSessionDestination) return;

  const navigator = navigateToSessionDestination;

  navigation = Promise.resolve()
    .then(async () => {
      const destination = getCurrentAuthUser() ? '/session-expired' : LOGIN_ROUTE;
      await navigator(destination);
    })
    .catch(() => {
      // Navigation failure must not create an unhandled rejection from an API callback.
    })
    .finally(() => {
      navigation = null;
    });
}
